module.exports = __webpack_public_path__ + "static/media/mstile-310x310.9a6f8de9.png";